import {
  ColumnElement,
  MarketingForgeElementType,
} from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { Flex } from "../../flex";
import { SignupFormDiscountCodeDisplay } from "./discount-code";
import { FormButton } from "./form-button";
import { FormImage } from "./form-image";
import { FormProduct } from "./form-product";
import { FormElementProps } from "./index";
import { Input } from "./input";
import { RichText } from "./rich-text";
import { TextToSubscribeButton } from "./text-to-subscribe-button";
import { TextToSubscribeDescription } from "./text-to-subscribe-description";

const elementComponents: Record<
  Exclude<MarketingForgeElementType, "container">,
  React.ComponentType<FormElementProps<any>>
> = {
  [MarketingForgeElementType.INPUT]: Input,
  [MarketingForgeElementType.RICH_TEXT]: RichText,
  [MarketingForgeElementType.BUTTON]: FormButton,
  [MarketingForgeElementType.IMAGE]: FormImage,
  [MarketingForgeElementType.PRODUCT]: FormProduct,
  [MarketingForgeElementType.DISCOUNT]: SignupFormDiscountCodeDisplay,
  [MarketingForgeElementType.COLUMN]: () => null, // Avoid recursion
  [MarketingForgeElementType.TEXT_TO_SUBSCRIBE_BUTTON]: TextToSubscribeButton,
  [MarketingForgeElementType.TEXT_TO_SUBSCRIBE_DESCRIPTION]:
    TextToSubscribeDescription,
};

export const FormColumn = memo(function FormColumn({
  element,
  ...props
}: FormElementProps<ColumnElement>) {
  const getColumnWidth = (index: number): string => {
    if (element.columnWidths && element.columnWidths[index]) {
      return `${element.columnWidths[index]}%`;
    }
    return `${100 / element.totalColumns}%`;
  };

  return (
    <Flex align="stretch" dir="row" justify="space-between" w="full">
      {element.elements.map((childElement, index) => {
        const ElementComponent = elementComponents[childElement.type];
        return (
          <Flex
            dir="column"
            key={index}
            style={{ width: getColumnWidth(index) }}
            w="full"
          >
            <Flex dir="column" flex={1} w="full">
              <ElementComponent element={childElement} {...props} />
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
});
